import { render, staticRenderFns } from "./UserSubjectMessageForm.vue?vue&type=template&id=51dbc56c&scoped=true&"
import script from "@/components/user-subject-message-form/UserSubjectMessageForm.ts?vue&type=script&lang=ts&"
export * from "@/components/user-subject-message-form/UserSubjectMessageForm.ts?vue&type=script&lang=ts&"
import style0 from "@/components/user-subject-message-form/user-subject-message-form.scss?vue&type=style&index=0&id=51dbc56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dbc56c",
  null
  
)

export default component.exports